import { Autocomplete, TextField } from '@mui/material';
import { forwardRef } from 'react';

type Option = { value: string; label: string };

interface Props {
  options: Option[];
  placeholder: string;

  /**
   * Useful inside a modal when we need a higher ZIndex for the menu
   */
  disablePortal?: boolean;
  disabled?: boolean;
  onChange: (value: Option[]) => void;
  label: string;
  denseMargin?: boolean;
  value: Option[];
  getOptionLabel?: (option: Option) => string;
}
export const MultiSelect: React.FC<Props> = forwardRef<any, Props>(
  (
    {
      options,
      denseMargin,
      placeholder,
      label,
      onChange,
      value,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <Autocomplete
        multiple
        ref={ref}
        disableCloseOnSelect
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={options}
        getOptionLabel={option => option.label}
        onChange={(_, data) => onChange(data)}
        value={value ?? []}
        {...props}
        renderInput={params => (
          <TextField
            {...params}
            placeholder={placeholder}
            autoComplete="off"
            fullWidth
            margin={denseMargin ? 'dense' : 'normal'}
            label={label}
          />
        )}
        disabled={disabled}
      />
    );
  }
);
